<template>
  <div id="enterpriseWrapper">
    <!-- 搜索栏 -->
    <div class="search-box">
      <div>
        <Select style="width:300px" v-model="selectValue" @on-change="handleSelectClick" :label-in-value="true">
          <Option v-for="(item,index) in getEnterpriseList" :value="item.dept_id" :key="index">{{item.dept_cn_name}}
          </Option>
        </Select>
      </div>
      <div>
        <Button v-if="hasPerm('org_department_add') == 2" class="ys-confirm" icon="ios-add"
          @click="addOneInfo">新建</Button>
      </div>
    </div>
    <!-- 表格 -->
    <el-table :columns="Columns" :tableData="tableData" :loading="tableLoading" :tableHeight="tableHeight"
      :isLoad="isLoad" :handleLoadData="handleLoadData" :rowKey="'dept_id'" @on-btn-click="onBtnClick"></el-table>
    <div v-if="modelMenu.isShow">
      <el-model :IsOpen="modelMenu.IsOpen" :IsAdd='modelMenu.IsAdd' :addData='modelMenu.addData'
        :ModelData='modelMenu.ModelData' @save_data='saveData' @close_modal="closeModal" :selectValue='selectValue'>
      </el-model>
    </div>
    <!-- 权限弹框 -->
    <jurisdiction-model :popoutType="1" :explainInfo="explainInfo" :MenuPermissionList="MenuPermissionList"
      :currentStatus="currentStatus" @on-jurisdiction-click="onJurisdictionClick"
      @selectedPermissionList="selectedPermissionList">
    </jurisdiction-model>
  </div>
</template>
<script>
  import JurisdictionModel from '_g/commonComponent/jurisdictionModel'; // 权限配置弹框
  import {
    sys_getMenuPermission,
    sys_setMenuPermission
  } from "@/utils/sys_utils/pulicServer" // 获取权限配置数据
  import {
    mapActions,
    mapGetters
  } from "vuex";
  import elementResizeDetectorMaker from "element-resize-detector"; // 获取元素的高度
  import ElTable from '_g/commonComponent/table/elTable.vue';
  import modelInfo from './model/_infoModel'
  export default {
    components: {
      'el-table': ElTable,
      "el-model": modelInfo,
      'jurisdiction-model': JurisdictionModel
    },
    computed: {
      ...mapGetters(["getEnterpriseList"])
    },
    data() {
      let _this = this;
      return {
        tableData: [], // 数据
        Columns: [{
            title: '部门名称',
            key: 'dept_cn_name',
            tree: true,
          },
          {
            title: '部门编号',
            key: 'branch_no'
          },
          {
            title: '部门类型',
            key: 'type_name',
            width: 300
          },
          {
            title: "权限配置",
            slot: "iconfontconfig",
            width: 100,
            iconClassConfig: [{
                name: "ys-iconshezhi",
                code: "perConfig",
                type: 'perConfig',
                status: 1,
                Pname: 'org_department_tabel_perConfig'
              }, // 配置
            ],
          },
          {
            title: '操作',
            slot: 'iconfont',
            width: 200,
            iconClass: [{
                name: 'ys-iconadd',
                code: 'add',
                status: 1,
                type: 'add',
                size: 'small',
                Pname: 'org_department_tabel_add'
              },
              {
                name: 'ys-iconbianji',
                code: 'edit',
                status: 1,
                type: 'edit',
                size: 'small',
                Pname: 'org_department_edit'
              },
              {
                name: 'ys-iconlajitongbeifen',
                code: 'remove',
                status: 1,
                type: 'remove',
                size: 'small',
                Pname: 'org_department_remove'
              }
            ]
          }
        ], // 表头
        totalCount: 100, // 总条数
        tableHeight: 0,
        searchValue: '', // 搜索框的值
        selectValue: '', // 下拉框选中的值
        selectTitle: "", // 下拉框选中的中文名字
        modelMenu: { //弹出框参数
          isShow: false,
          IsOpen: false,
          IsAdd: 1,
          addData: {},
          ModelData: {}
        },
        isLoad: true, //是否需要懒加载
        showAddBtn: false, //是否显示新增按钮
        // 权限配置相关变量
        explainInfo: {}, // 权限配置弹框头部基础信息
        MenuPermissionList: [], // 菜单权限数据列表
        currentStatus: false, // 打开权限列表弹框
        tableLoading: true, // 表格loading
      }
    },
    created() {
      this.getEnterListInit();
    },
    methods: {
      ...mapActions([
        "sa_DpDeptView_qryDpDeptOneInfo",
        "dp_UpdateDeptAction",
        "dp_QueryDeptInfoAction",
        "DpDeptView_rmDpDeptInfo",
        "dp_AddDeptAction",
        "DpDeptView_qryDpDeptInfoList",
        "sa_DpDeptView_qryDpDeptInfo"
      ]),
      // 获取元素的高度
      getElementHeight() {
        let ERD = elementResizeDetectorMaker();
        let _this = this;
        ERD.listenTo(document.getElementById("enterpriseWrapper"), (element) => {
          _this.tableHeight = (element.scrollHeight - 66 - 90);
        });
      },
      addOneInfo() {
        let dataInfo = {};
        this.getEnterpriseList.forEach(item => {
          if (this.selectValue == item.dept_id) {
            dataInfo = item;
          }
        })
        this.onBtnClick(dataInfo, {
          type: "add"
        });
      },
      // 操作按钮
      onBtnClick(rowItem, options) {
        switch (options.type) {
          case "add":
            this.modelMenu.addData = {
              "super_dept_id": rowItem.dept_id,
              "super_dept_cn_name": rowItem.dept_cn_name,
              "dept_level": rowItem.dept_level + 1,
              "dept_id": ""
            };
            this.modelMenu.ModelData = {};
            this.modelMenu.isShow = true;
            this.modelMenu.IsOpen = true;
            this.modelMenu.IsAdd = 1;
            break;
          case "remove":
            this.removeView(rowItem.dept_id);
            break;
            // 权限配置
          case "perConfig":
            this.explainInfo = rowItem;
            this.getPermissionInfo({
              type_code: 'dpdept', // 部门类型
              org_dept_id: rowItem.dept_id, // 部门ID 
              cull_type: "cull",
              ent_no: this.selectValue, // 所属企业ID
            });
            // 每次请求都需要清除原来数据 
            this.MenuPermissionList = [];
            this.currentStatus = true;
            break;
          case 'edit':
            this.getItemInfo(rowItem)
            break;
        }
      },
      // 搜索功能
      handleSearchClick() {},
      // 下拉框选中
      handleSelectClick(info) {
        this.selectTitle = info.label;
        this.selectValue = info.value;
        this.getListData();
      },
      // 分页功能
      handlePagingClick(res) {},
      //平级数据改成tree数据
      coverList(list, num, meaid) {
        let newList = [],
          newStatus = false,
          newSuperDeptIds = [];
        list.forEach(item => {
          if (item.dept_level == (num + 1)) {
            newStatus = true;
            if (item.super_dept_id && newSuperDeptIds.indexOf(item.super_dept_id) == -1) {
              newSuperDeptIds.push(item.super_dept_id);
            }
          }
        })
        list.forEach(item => {
          if (item.dept_level == num) {
            if (item.super_dept_id && meaid && item.super_dept_id == meaid) {
              if (newSuperDeptIds.indexOf(item.dept_id) != -1) {
                let obj = this.coverList(list, num + 1, item.dept_id);
                newList.push({
                  ...item,
                  children: obj
                })
              } else {
                newList.push(item);
              }
            } else if (!meaid) {
              if (newSuperDeptIds.indexOf(item.dept_id) != -1) {
                let obj = this.coverList(list, num + 1, item.dept_id);
                newList.push({
                  ...item,
                  children: obj
                })
              } else {
                newList.push(item);
              }
            }
          }
        })

        return newList;
      },
      //获取主列表数据
      getListData() {
        this.tableLoading = true;
        this.sa_DpDeptView_qryDpDeptOneInfo({
          "dept_id": this.selectValue,
          "ent_no": this.selectValue
        }).then(res => {
          let len = this.tableData.length,
            list = res.dpDeptBeanList ? res.dpDeptBeanList : "";
          if (!list) {
            this.tableData = [];
            this.showAddBtn = true;
            return false
          }
          this.showAddBtn = false;
          list.forEach(item => {
            if (item.type_status == 1) {
              item["_loading"] = false;
              item["children"] = [];
            }
          })
          this.tableData.splice(0, len, ...list);
          this.tableLoading = false;
        }).catch(err => {
          this.tableLoading = false;
        })
      },
      //查看当前部门的信息
      getItemInfo(deptInfo) {
        this.dp_QueryDeptInfoAction({
          dept_id: deptInfo.dept_id
        }).then(res => {
          this.modelMenu.ModelData = {
            ...res
          };
          // 如果是编辑的一级部门  则顶级部门就是企业
          if (res.dept_level === 1) {
            this.modelMenu.ModelData.super_dept_cn_name = this.selectTitle;
          }
          this.modelMenu.addData = {};
          this.modelMenu.IsAdd = 3;
          this.modelMenu.isShow = true;
          this.modelMenu.IsOpen = true;
        })
      },
      //新增编辑保存
      saveData(options, callback) {
        let _this = this;
        if (this.modelMenu.IsAdd == 1) {
          this.dp_AddDeptAction({
            ...options,
            "dept_id": this.selectValue
          }).then(res => {
            if (res) {
              this.$Message.success("新增部门成功！");
              this.closeModal();
              this.handleLoadData({
                "dept_id": options.super_dept_id
              }, function (data) {
                let listData = JSON.parse(JSON.stringify(_this.tableData)),
                  len = _this.tableData.length,
                  listInfo = _this.coverListData(listData, data, options.super_dept_id);
                _this.tableData.splice(0, len, ...listInfo);
              })
              this.getListData();
              callback();
            }
          })
        } else {
          this.dp_UpdateDeptAction({
            ...options
          }).then(res => {
            if (res) {
              this.$Message.success("修改部门成功！");
              this.closeModal();
              this.getListData();
              callback();
            }
          })
        }
      },
      //关闭弹框
      closeModal() {
        this.modelMenu.IsOpen = false;
        this.modelMenu.isShow = false;
      },
      //删除部门行数据
      removeView(dept_id) {
        this.$Modal.confirm({
          title: '删除',
          content: '<p>确定删除当前分组信息嘛？</p>',
          onOk: () => {
            this.DpDeptView_rmDpDeptInfo({
              dept_id
            }).then(res => {
              if (res) {
                this.$Message.success("删除成功！");
                this.getListData();
              }
            })
          },
          onCancel: () => {}
        });
      },
      //获取企业下拉列表
      getEnterListInit() {
        // 默认选择第一个企业
        this.$nextTick(() => {
          if (this.getEnterpriseList && this.getEnterpriseList.length > 0) {
            this.selectValue = this.getEnterpriseList[0].dept_id;
            this.selectTitle = this.getEnterpriseList[0].dept_cn_name;
            //获取列表数据
            this.getListData();
          }
        });
      },
      //异步加载表格数据
      handleLoadData(item, callback) {
        let data = [];

        this.sa_DpDeptView_qryDpDeptInfo({
          "dept_id": item.dept_id,
          "ent_no": this.selectValue
        }).then(res => {
          if (res.dpDeptBeanList) {
            let list = res.dpDeptBeanList;
            list.forEach(item => {
              if (item.type_status == 1) {
                item["_loading"] = false;
                item["children"] = [];
              }
            })
            data = list;
            callback(data)
          } else {
            callback(data)
          }
        })
      },
      // 配置权限弹框回调
      onJurisdictionClick(res) {
        this.currentStatus = false;
      },
      // 获取权限数据信息
      getPermissionInfo(params) {
        sys_getMenuPermission(params).then(res => {
          if (res) {
            this.MenuPermissionList = res;
          }
        }).catch(err => {
          // this.$Message.error(err);
        })
      },
      // 保存配置的权限数据
      selectedPermissionList(menuList, BtnList) {
        // 如果返回菜单权限
        if (menuList) {
          let params = {
            dept_id: this.explainInfo.dept_id, //当前部门ID
            rs_ary: menuList,
            opt_priv: []
          }
          sys_setMenuPermission(params).then(res => {
            if (res) {
              this.$Message.success("权限配置成功！")
            }
          }).catch(err => {
            // this.$Message.error(err);
          })
        }
        if (BtnList) {

        }
      },
      //递归更新
      coverListData(list, data, super_dept_id) {
        list.forEach(item => {
          if (item.dept_id == super_dept_id) {
            if (item.children && item.children.length) {
              item.children = data;
            } else {
              item["_loading"] = false;
              item.children = data;
            }
          }
          if (item.children && item.children.length) {
            item.children = this.coverListData(item.children, data, super_dept_id);
          }
        })

        return list;
      }
    },
    mounted() {
      // 获取元素高度
      this.getElementHeight();
    },
    watch: {
      getEnterpriseList() {
        this.getEnterListInit();
      }
    }
  }
</script>
<style lang="less" scoped>
  #enterpriseWrapper {
    position: relative;
    width: 100%;
    height: 100%;
    padding: 0 50px;
    box-sizing: border-box;

    .search-box {
      width: 100%;
      height: 66px;
      padding: 22px 0px 12px 0px;
      box-sizing: border-box;
      display: flex;
      flex-wrap: nowrap;
      justify-content: space-between;

      .ivu-select {
        margin-right: 12px;
      }
    }

    .paging-box {
      position: fixed;
      bottom: 0px;
      right: 50px;
      z-index: 1;
      height: 60px;
      width: calc(100% - 250);
      text-align: right;
    }

    .dept_cn_name {
      text-decoration: underline;
      color: blue;
    }
  }
</style>